// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"Footer_majorContainer__9BR9z","main":"Footer_main__lyiaJ"};